export const GetLocalizedText = (localizedText: any, lang: string): string =>
  localizedText[lang] ?? '';
